import React, {Component} from "react";
import ApiService from "../../services/api";
import Loading from '../loading/loading'
import M from 'materialize-css'
import configs from "../../../configs.json"

const apiservice = new ApiService()

class Signup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            username : "",
            password1: "",
            password2: "",
            email    : "",
            redirect : null
        }
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    showErrorToast(message) {
        M.toast({ html: message, classes: 'red darken-2' })
    }

    getAuth() {
        const user  = localStorage.getItem('user')
        const token = localStorage.getItem('token')

        const req = new FormData()
        req.append('user', user)
        req.append('token', token)

        apiservice.hasAuth(req).then((res) => {
            const auth = res.auth
            switch (auth) {
                case 'Visitor':
                    this.setState({ redirect : false })
                    break
                case 'User':
                    this.setState({ redirect : true })
                    break
                case 'Client':
                    this.setState({ redirect : true })
                    break
                default:
                    this.setState({ redirect : false })
            }
        }).catch(() => {
            // Keep signup page usable even when backend is offline.
            this.setState({ redirect : false })
        })
    }

    componentDidMount() {
        this.getAuth()
    }

    handleSubmit(event) {
        event.preventDefault()
        if (this.state.password1 === this.state.password2) {
            const data = new FormData()

            data.append("username", this.state.username)
            data.append("email"   , this.state.email)
            data.append("password1", this.state.password1)
            data.append("password2", this.state.password2)
            

            apiservice.signUp(data).then((r) => {
                localStorage.setItem('token', r.token)
                localStorage.setItem('user', this.state.username)
                this.setState({redirect: true})
            }).catch(() => {
                this.showErrorToast('Nao foi possivel concluir o cadastro agora. Tente novamente em instantes.')
            })
        } else {
            this.showErrorToast("As senhas nao conferem.")
        }
    }

    render() {
        if (this.state.redirect === false) {
            return(
                <div className="container center" id='signup'>
                    <div className="card center-align" style={{backgroundColor: configs.colors.primary}}>
                        <div className="card-title" style={{borderBottom: '1px solid ' + configs.colors.secondary}}>
                            <h4>Registrar</h4>
                        </div>
                        <form method="POST" encType="multipart/form-data" onSubmit={this.handleSubmit} >
                            <div className="card-content white-text">
                                <div className="center">
                                    <div className="row">
                                        <label htmlFor="input_text">Usuário</label>
                                        <input id="input_text" type="text" placeholder="User123" onChange={(e) => {this.setState({username: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}} required/>
                                    </div>
                                </div>
                                <div className="center">
                                    <div className="row">
                                        <label htmlFor="input_text">Email</label>
                                        <input id="input_text" type="text" placeholder="exemplo@email.com" onChange={(e) => {this.setState({email: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}} required />
                                    </div>
                                </div>
                                <div className="center">
                                    <div className="row">
                                        <label htmlFor="input_text">Senha</label>
                                        <input id="input_text" type="password" placeholder="********" onChange={(e) => {this.setState({password1: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}} required/>
                                    </div>
                                </div>
                                <div className="center">
                                    <div className="row">
                                        <label htmlFor="input_text">Confirmação da senha</label>
                                        <input id="input_text" type="password" placeholder="********" onChange={(e) => {this.setState({password2: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}} required/>
                                    </div>
                                </div>
                                <div className="center">
                                    <div className="row">
                                        <label>
                                            <input type="checkbox" className="filled-in" required/>
                                            <span>Li e aceito os <a href={configs.links.terms} style={{color: configs.colors.secondary}}>Termos e Condições de Uso</a></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="card-action" style={{borderTop: '1px solid ' + configs.colors.secondary}}>
                                <button type='submit' className="btn waves-effect waves-light hoverable" style={{backgroundColor: configs.colors.secondary}}>
                                    Registrar<i className="material-icons right">send</i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )
        }
        if (this.state.redirect === true) {
            window.location.replace(process.env.REACT_APP_URL)
        }
        if (this.state.redirect === null) {
            return (
                <Loading/>
            )
        }
    }
}

export default Signup;